// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    COMPANY_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexSectionPage: action.companyIndexSectionPage
      };
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-innovative-companies',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.companyIndexSectionPage,
        ads: adModelData
      };
    },
    COMPANY_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
